/**
 * Shared timezone dropdown options for both manual and self-schedule
 * calendars — so the wizard always ships the same curated
 * human-friendly list (e.g. `Indian Standard Time (GMT+05:30) - Kolkata`)
 * instead of bare IANA names like `Asia/Calcutta`.
 *
 * Pulled from `TIME_ZONE_CONSTANTS` — same source the legacy
 * KInterviewScheduler SchCalToolbar used via `me/edit`. DST-aware
 * offsets are recomputed on each call.
 */
import moment from 'moment-timezone';
import { TIME_ZONE_CONSTANTS } from '@/utils/timeZoneConstants';

export interface TimezoneOption {
  value: string;
  label: string;
}

export function buildTimezoneOptions(): TimezoneOption[] {
  return Object.entries(TIME_ZONE_CONSTANTS)
    .filter(([key]) => moment.tz.zone(key) !== null)
    .map(([key, meta]) => {
      const m = meta as { fullName?: string; shortName?: string };
      const offsetMinutes = moment.tz(key).utcOffset();
      const sign = offsetMinutes < 0 ? '-' : '+';
      const hh = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(
        2,
        '0'
      );
      const mm = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');
      const liveOffset = `GMT${sign}${hh}:${mm}`;
      const fullName = m.fullName ?? key;
      const shortName = m.shortName ?? key;
      return {
        value: key,
        label: `${fullName} (${liveOffset}) - ${shortName}`,
      };
    });
}
